import { render } from "./withdrawal.vue?vue&type=template&id=43cf5ef3&lang=html"
import script from "./withdrawal.vue?vue&type=script&lang=js"
export * from "./withdrawal.vue?vue&type=script&lang=js"

import "./withdrawal.vue?vue&type=style&index=0&id=43cf5ef3&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__